export default "__VITE_ASSET__0nNFDt94__"